import { NewMainContext } from '../context/MainContext';
import { ButtonContinueRead } from './Button';
import '../styles/Modal.css';
import { AiFillCloseCircle } from 'react-icons/ai';

export const ModalFromSaved = (props, show) => {
  let { setOpenModalFromSaved } = NewMainContext();
  const showHideClassName = show ? 'popup display-block' : 'popup display-none';

  return (
    <div className={showHideClassName}>
      <div className='popup2'>
        <div className='modal-from-saved'>
          <h1 className='modal-from-saved__title'>
            Apakah Anda ingin melanjutkan?
          </h1>
          <div className='modal-from-saved__button'>
            <button
              onClick={() => setOpenModalFromSaved(false)}
              className='modal-from-saved__no'
            >
              Tidak
            </button>
            <div onClick={() => setOpenModalFromSaved(false)}>
              <ButtonContinueRead name={'Lanjutkan'} ayat={props.linkList} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ModalDetail = ({
  saveHistory,
  saveLastRead,
  closePopup2,
  show,
}) => {
  const showHideClassName2 = show
    ? 'popup display-block'
    : 'popup display-none';
  return (
    <div className={showHideClassName2}>
      <div className='popup2'>
        <button onClick={saveLastRead} className='save save-lastread'>
          Simpan ke terakhir dibaca
        </button>
        <button onClick={saveHistory} className='save save-history'>
          Simpan ke terakhir dihafal
        </button>
        <button onClick={closePopup2} className='close'>
          <AiFillCloseCircle className='close-icon' />
        </button>
      </div>
    </div>
  );
};
